import Globals from "../../api";
import { Helmet } from "react-helmet";
import React from "react";
import "./cricketscorecard.scss";
import Rightbar from "../../components/Rightbar/Rightbar";
import { Suspense, lazy } from "react";
import ReactHtmlParser from "react-html-parser";
import axios from "axios";
export default class CricketPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      html : [],
      meta_description : [],
      title : [],
      meta_keywords : [],
      Rightbar : [],
      AdData :[],
      CricketData : []
    };
  }
  getRightbar(){
    const url= Globals.Rightbar_api+"/sports-news-in-kannada";
    fetch(url)
    .then((res) => res.json())
    .then((data) => {
        
        this.setState({
          Rightbar : data.Contents[0]
        })
    })   
  }   
  getAds(){
    const url= Globals.AdConfig;
            fetch(url)
            .then((res) => res.json())
            .then((data) => {
              
                this.setState({
                  AdData : data.AdContents[0].ROS
                })
                
            }) 
            
  }
  getCricketUpdate(){
    const url= Globals.Cricket_update_api;
    //const url ="https://m-marathidev.webdunia.com/ad-config/ticker-test.json";
    fetch(url)
    .then((res) => res.json())
    .then((data) => {
        this.setState({
          CricketData : data.CurrentMatches
          
        })
    })   
    //console.log("url ",url)
  } 
  componentDidMount() {
    let url = window.location.pathname;
    var matchId;
    if(url == '/cricket-score-card'){
      matchId = '';  
      var cricketURL = Globals.language_based_api+"/cricket-score-card";
      fetch(cricketURL)
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          html: data.Contents[2].Html,
          title : data.Title,
          meta_keywords: data.Meta.keywords.Attributes.content,
          meta_description: data.Meta.description.Attributes.content
        });
      });
    }
    else if(url == '/cricket-fixtures'){
     // var cricketURL ="https://api-en.webdunia.com/getCricketFixture?langCode=hi";
      var cricketURL = "http://cricketadmin.webdunia.com:200/admin/cricket/worldCupWidgets/tm/allfixtures.htm#odi"
      axios({
             method : "GET",
             url :cricketURL
            
         }) 
      .then((data) => {
        this.setState({
          html: data.data
          
        });
      });
    }else{
      matchId = url.match(/(\d+)/)[0];
      var cricketURL = Globals.language_based_api+"/cricket-score-card/"+ matchId +".html";
      fetch(cricketURL)
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          html: data.Contents[2].Html,
          title : data.Title,
          meta_keywords: data.Meta.keywords.Attributes.content,
          meta_description: data.Meta.description.Attributes.content
        });
      });
    }
    //const categoryListURL = "http://api.webdunia.com/scorecardJson?MatchId="+ matchId +"&LangId=1&InningId=1";
    
      this.getRightbar();
      this.getAds();
      this.getCricketUpdate();
  }



  render() {
    //console.log("html :",this.state.html);
    
    const renderLoader = () => <p>Loading</p>;
    let categoryList = this.state.html;
    return (
      <div>
        <Helmet>
        <script src="http://toolbardata.webdunia.com/cricket/worldCupWidgets/jquery.js" type="text/javascript" charset="utf-8"></script>
          <script src="http://toolbardata.webdunia.com/cricket/worldCupWidgets/jquery.tabify.js" type="text/javascript" charset="utf-8"></script> 
        <script src= "/js/cricket.js" async ></script>
          <title>{this.state.title}</title>
          <meta name="keywords" content={this.state.meta_keywords} />
          <meta name="description" content={this.state.meta_description} />
         
        </Helmet>
        <h1>{categoryList.title}</h1>
        <div className="container padding15">
          <div className="row">
              <div className="col">
                <div className="cricket_score_wrap">
                <div dangerouslySetInnerHTML={{ __html: this.state.html }} />
                </div>
              </div>
              
              <div className="col right_side_bar">
              <Rightbar Rightbar={this.state.Rightbar} googleAds = {this.state.AdData} CricketData={this.state.CricketData}/>
              </div>
          </div>
        </div>
      </div>
    );
  }
}
